import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";

createRoot(document.getElementById("root")!).render(<App />);

// PWA: manifest + icons (added via JS to avoid Bun bundler resolving them)
const manifest = document.createElement("link");
manifest.rel = "manifest";
manifest.href = "/manifest.json";
document.head.appendChild(manifest);

const touchIcon = document.createElement("link");
touchIcon.rel = "apple-touch-icon";
touchIcon.href = "/icons/icon-192.png";
document.head.appendChild(touchIcon);

// Register service worker with auto-reload on update
if ("serviceWorker" in navigator) {
  // Only auto-reload if a SW was already active (update, not first install)
  if (navigator.serviceWorker.controller) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  }
  navigator.serviceWorker.register("/sw.js").catch(() => {});
}
